/**
 * Format a currency value with the given currency code
 */
export const formatCurrency = (
  value: number,
  currencyCode: string = "EUR"
): string => {
  return new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

/**
 * Format a date as DD-MM-YYYY
 */
export const formatDate = (date: string | Date): string => {
  if (!date) return "";
  const d = new Date(date);
  return `${d.getDate().toString().padStart(2, "0")}-${(
    d.getMonth() + 1
  ).toString().padStart(2, "0")}-${d.getFullYear()}`;
};

/**
 * Format a number with thousand separators
 */
export const formatNumber = (
  value: number,
  decimals: number = 2
): string => {
  return new Intl.NumberFormat("nl-NL", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
}; 